import { IColumn } from '../../../../types/IColumn';

export const searchRegex = (searchQuery: string): RegExp => new RegExp(searchQuery, 'i');

export const filterColumns = (columns: IColumn[], searchQuery: string) => columns
  .filter((s) => s.name.search(searchRegex(searchQuery)) !== -1);
